module.exports = __webpack_public_path__ + "static/media/mobile.d6c20695.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Aya/mobile.png
// module id = 157
// module chunks = 0